module.exports = __webpack_public_path__ + "img/4_50.a86aa351.png";